import { adminHttpClient } from '../commons/adminHttpClient'
import { NamedItemInt } from '../../domain/common/namedItem'

export type CompanyTypeResponse = NamedItemInt & {
  description: string
}

export const getCompanyTypes = (): Promise<CompanyTypeResponse[]> => {
  return adminHttpClient.get(`/Companies/CompanyTypes`)
}
